<template>
  <div>
    <!-- Technical supports -->
    <h3>PCN & EOL Policy</h3>
    <div class="py-5">
      資料救援內容，可自行添加欄位數量，以一個標題搭配一個段落內容為單位新增。
    </div>

    <div>
      <!-- itemList -->
      <PageCollapse v-for="(item, i) in support.technical_supports" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Support {{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- Basic section -->
          <div>
            <!-- Title -->
            <label class="form-item d-flex py-5">
              <div class="w-174px mr-6">
                <h4>Title</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <v-textarea
                  v-model="item.title"
                  outlined
                  dense
                ></v-textarea>
              </div>
            </label>
            <!-- Content -->
            <div class="d-flex pa-5">
              <div class="w-174px mr-6">
                <h4>Content</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <editor
                  :key="item.id"
                  v-model="item.content"
                  :plugins="'link image'"
                  :toolbar="'link bold image'"
                  :height="200"
                />
              </div>
            </div>
          </div>
        </template>
      </PageCollapse>
      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加一組Title+Content</span>
        </button>
      </div>
    </div>

    <!-- Compatibility Search -->
    <h3 class="pt-5">Compatibility Search</h3>
    <div class="py-5">串接資料，不於後台編輯(TBD)</div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Editor,
    PageCollapse,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        content: '',
      };
      this.support.technical_supports.push(template);
    },
    deleteItem(item) {
      const index = this.support.technical_supports.map((option) => option.id).indexOf(item.id);
      this.support.technical_supports.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.technical_supports.length - 1) {
        this.support.technical_supports.splice(i, 1);
        this.support.technical_supports.unshift(item);
        return;
      }
      // item become next index
      this.support.technical_supports.splice(i, 1);
      this.support.technical_supports.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.technical_supports.splice(i, 1);
        this.support.technical_supports.push(item);
        return;
      }
      // item become previous index
      this.support.technical_supports.splice(i, 1);
      this.support.technical_supports.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
